import React from 'react';

interface FloatingInputProps {
  inputId?: string;
  defaultValue?: string;
  label?: string;
  type?: string;
  min?: number;
  max?: number;
  step?: number;
  maxLength?: number;
  disabled?: boolean;
  fullWidth?: boolean;
  onChange?: (value: string | number) => void;
  values?: Record<string, unknown>;
}

interface FloatingInputState {
  value: string | undefined;
  active: boolean;
}

export default class FloatingInput extends React.Component<FloatingInputProps, FloatingInputState> {
  static defaultProps = {
    inputId: null,
    defaultValue: '',
    label: '',
    type: 'text',
    disabled: false,
    onChange: () => {},
    values: {},
  };

  constructor(props: FloatingInputProps) {
    super(props);
    this.state = {
      value: this.props.defaultValue,
      active: !(
        this.props.defaultValue === undefined ||
        this.props.defaultValue.length === 0
      ),
    };
  }

  render() {
    return (
      <div className={'float-container' + (this.state.active ? ' active' : '')}>
        <label>{this.props.label}</label>
        <input
          id={this.props.inputId}
          type={this.props.type ? this.props.type : 'text'}
          min={this.props.min}
          step={this.props.step}
          maxLength={this.props.maxLength ? this.props.maxLength : 50}
          value={this.state.value}
          disabled={this.props.disabled}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            if (this.props.onChange) {
              this.props.onChange(
                this.props.type === 'number'
                  ? parseFloat(e.target.value)
                  : e.target.value
              );
            }
            this.setState({
              value: e.target.value,
              //active: e.target.value === undefined ? false : true,
            });
          }}
          onFocus={() => {
            this.setState({ active: true });
          }}
          onBlur={() => {
            if (!this.state.value) {
              this.setState({ active: false });
            }
          }}
        />
      </div>
    );
  }
}
